import { OpcCatalogo, Opcion } from "../models/catalogo.type";

/**
 * Transforma arreglo de catalogos API (OpcCatalogo) al formato Opcion (valor/etiqueta/ext5)
 * que usan los FormSelect de la UI.
 */
export const transformarOpciones = (arrOpcCatalogo: OpcCatalogo[]): Opcion[] => {
  return arrOpcCatalogo.map(opc => {
    return {
      valor: opc.value,
      etiqueta: opc.description,
      ext5: opc.ext5
    }
  })
}